import React, { useState } from "react";
import './NavbarBootrap.css';
import { NavLink } from "react-router-dom";
import { Button, Container, Modal, Nav, Navbar, NavDropdown, Spinner, DropdownButton, ButtonGroup, Dropdown } from "react-bootstrap";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import { HelpFunctions } from "helpers/HelpFunctions";
import CrudErrors from "./CrudErros";
import Swal from "sweetalert2";
import { HelpHttp } from "helpers/HelpHttp";

const { REACT_APP_API } = process.env;
const initialForm = { password: '', newPassword: '', repeatNewPassword: '' };

const NavbarBootrap = () => {
    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState(null);
    const [form, setForm] = useState(initialForm);
    const [loading, setLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const handleChange = (e) => {
        setForm({ ...form, [e.target.id]: e.target.value });
    }

    let f = HelpFunctions();
    let api = HelpHttp();

    const handleLogout = () => f.logout();
    let name = f.alias();

    let myAbilities = HelpAbility();
    const handleSubmitUpdatePass = (e) => {
        e.preventDefault();
        updatePass(form);
    }
    const updatePass = (data) => {
        setErrors(null);
        if (!data.password) {
            setErrors([{ field: 'password', error: 'La contraseña actual es obligatoria' }]);
            return;
        } else if (!data.newPassword) {
            setErrors([{ field: 'newPassword', error: 'La nueva contraseña es obligatoria' }]);
            return;
        } else if (data.newPassword !== data.repeatNewPassword) {
            setErrors([{ field: 'password', error: 'Las nuevas contraseñas no coinciden' }]);
            return;
        }

        let dataSend = { password: data.password, newPassword: data.newPassword };
        let url = `${REACT_APP_API}/users`

        let endPoint = `${url}/myPass`;
        let options = { body: dataSend, headers: { 'content-type': 'application/json' } };
        setLoading(true);
        api.post(endPoint, options).then(res => {
            setLoading(false);
            if (res.err) {
                // setRequestErrorUpdatePass(res);
                Swal.fire('¡Error!', 'Ocurrió un error, intente más tarde', 'error');
            } else {
                // setRequestErrorUpdatePass(null);
                if (res.status) {
                    handleClose();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }

    return (
        <>

            <Navbar bg="avatar" expand="lg" variant="avatar">
                <Container>
                    <NavLink className="navbar-brand" exact to="/">
                        <img src="/img/avatar.jpg" alt="Avatar" height="24" className="d-inline-block rounded-circle"
                            style={{ background: 'rgba(255, 255, 255, 1)' }} />
                        &nbsp; Administrador de Servicios
                    </NavLink>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <NavLink exact className="nav-link" to="/" aria-current="page">Inicio</NavLink>
                        </Nav>
                        <Nav>

                            <NavDropdown title="Gestión" id="gestion-nav-dropdown">
                                {(myAbilities.has(C.A.SERVICE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                    <NavDropdown.Item href="/services">Servicios</NavDropdown.Item>}
                                    <NavDropdown.Item href="/consultreport">Consulta Reporte</NavDropdown.Item>

                                {(myAbilities.has(C.A.SERVICE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <DropdownButton as={ButtonGroup} key="gtw" id="dropdown-button-drop-end" drop="end" variant="avatar" title="GW Pagos Avatar">
                                    <Dropdown.Item href="/phrame.php">GW Pagos Avatar B2C</Dropdown.Item>
                                    <Dropdown.Item href="/b2b/phrame.php">GW Pagos Avatar B2B</Dropdown.Item>
                                    <Dropdown.Item href="/aliados/phrame.php">GW Pagos Avatar Aliados</Dropdown.Item>
                                </DropdownButton>}

                                {(myAbilities.hasAnyStartedWith(C.A.PARAMETER.UPDATE) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                    <NavDropdown.Item href="/parameters">Configuración de servicios</NavDropdown.Item>}

                                <NavDropdown.Item href="/groups">Configuración de Grupos</NavDropdown.Item>

                                <NavDropdown.Item href="/idclaro">IdClaroAvatar</NavDropdown.Item>

                                <NavDropdown.Item href="/mail">Bandeja Email</NavDropdown.Item>

                                {myAbilities.hasRol(C.R.DESARROLLADOR) && <DropdownButton as={ButtonGroup} key="datos-v8" id="dropdown-button-drop-end" drop="end" variant="avatar" title="Datos V8">
                                    {(myAbilities.has(C.A.PRODUCT.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                        <Dropdown.Item href="/products" eventKey="1">Productos</Dropdown.Item>}

                                    {(myAbilities.has(C.A.CUSTOMER.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                        <Dropdown.Item href="/clients" eventKey="2">Clientes</Dropdown.Item>}

                                    {(myAbilities.has(C.A.LINE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                        <Dropdown.Item href="/lines" eventKey="3">Lineas</Dropdown.Item>}

                                    {(myAbilities.has(C.A.DEPARTAMENT.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                        <Dropdown.Item href="/departaments" eventKey="4">Departamentos</Dropdown.Item>}

                                    {(myAbilities.has(C.A.DIRECTION.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                        <Dropdown.Item href="/directions" eventKey="4">Direcciones</Dropdown.Item>}

                                    {(myAbilities.has(C.A.EMAIL.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                        <Dropdown.Item href="/emails" eventKey="4">Correos</Dropdown.Item>}

                                    {(myAbilities.has(C.A.CENTER.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                        <Dropdown.Item href="/centers" eventKey="5">Centros/Agentes</Dropdown.Item>}

                                    {(myAbilities.has(C.A.ORGANIZACION.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                        <Dropdown.Item href="/organization" eventKey="6">Organizaciones</Dropdown.Item>}

                                    {(myAbilities.has(C.A.FLUJOSSTRUCTURE.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) &&
                                        <Dropdown.Item href="/flujos-estructure">Flujos Estructure</Dropdown.Item>}

                                    {(myAbilities.has(C.A.NIVELESSTRUCTURE.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) &&
                                        <Dropdown.Item href="/niveles">Niveles Flujos</Dropdown.Item>}

                                    {(myAbilities.has(C.A.FLUJOSADDRESSCOMPLEMENT.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) &&
                                        <Dropdown.Item href="/flujos-address-complement">Flujos Address Complement</Dropdown.Item>}
                                </DropdownButton>}


                                {myAbilities.hasRol(C.R.DESARROLLADOR) && <DropdownButton as={ButtonGroup} key="datos-v9" id="dropdown-button-drop-end" drop="end" variant="avatar" title="Datos V9">
                                    {(myAbilities.has(C.A.SERVICIOSHOGARPLANES.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) && <NavDropdown.Item href="/servicios-hogar-planes">Servicios Hogar Planes</NavDropdown.Item>}
                                </DropdownButton>}
                            </NavDropdown>

                            {(myAbilities.has(C.A.USER.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) &&
                                <NavDropdown title="Administración" id="administration-nav-dropdown">
                                    <NavDropdown.Item href="/users">Usuarios</NavDropdown.Item>
                                </NavDropdown>}
                            <NavDropdown title={name} id="basic-nav-dropdown">
                                <NavDropdown.Item href="#" onClick={handleShow}>Cambiar Contraseña</NavDropdown.Item>
                                <NavDropdown.Item href="#" onClick={handleLogout}>Cerrar Sesión</NavDropdown.Item>
                            </NavDropdown>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Cambiar Contraseña</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Se recomienda usar una contraseña segura que no uses en ningún otro sitio.</p>
                    <small>La contraseña debe tener como mínimo :</small>

                    <div className="row">
                        <div className="col-md-6">
                            <ul>
                                <li><span className="badge bg-light text-dark">8 caracteres</span></li>
                                <li><span className="badge bg-light text-dark">1 letra mayúscula</span></li>
                                <li><span className="badge bg-light text-dark">1 letra minúscula</span></li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul>
                                <li><span className="badge bg-light text-dark">1 dígito</span></li>
                                <li><span className="badge bg-light text-dark">1 símbolo</span></li>
                            </ul>
                        </div>
                    </div>
                    {errors && <CrudErrors errors={errors} />}
                    <form>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="password" className="col-form-label">Contraseña Actual:</label>
                                    <input type="password" className="form-control" id="password"
                                        onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="newPassword" className="col-form-label">Contraseña Nueva:</label>
                                    <input type="password" className="form-control" id="newPassword"
                                        onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="repeatNewPassword" className="col-form-label">Repetir Contraseña
                                        Nueva:</label>
                                    <input type="password" className="form-control" id="repeatNewPassword"
                                        onChange={handleChange} />
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>

                    {!loading &&
                        <Button variant="primary" onClick={handleSubmitUpdatePass}><i
                            className="bi bi-save" /> Guardar cambios</Button>}
                    {loading && <Button variant="primary" disabled>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        &nbsp; Guardando...
                    </Button>}
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default NavbarBootrap;
